import { useTranslation } from 'react-i18next';

import { PaymentSettings } from '../usePaymentSettings';

type PaymentMethodInfo = {
  type?: string;
  isPayInPerson?: boolean;
};

export const usePaymentDisclaimer = () => {
  const { t } = useTranslation();

  const generateDisclaimerText = (settings: PaymentSettings, selectedPayment?: PaymentMethodInfo) => {
    const isCustomerChoosingToPrepay =
      selectedPayment &&
      !selectedPayment.isPayInPerson &&
      selectedPayment.type !== 'payInPerson' &&
      selectedPayment.type !== 'payInStore';

    if (settings.requiresPrepayment || settings.requiresPartialDeposits || isCustomerChoosingToPrepay) {
      return t('components.checkoutFormPopup.paymentDisclaimer.yourCardWillBeChargedToday');
    }

    if (settings.allowInPersonPayments && !settings.requestCardForInPersonPayments) {
      return t('components.checkoutFormPopup.paymentDisclaimer.shopAllowsInPersonPayments');
    }

    return null;
  };

  return {
    generateDisclaimerText,
  };
};
